export default [
    {
        id: 'S',
        label: 'Short',
    },
    {
        id: 'L',
        label: 'Large',
    },
    {
        id: 'A',
        label: 'Arc',
    },
];
